import { render, staticRenderFns } from "./sceneImportTemplate.vue?vue&type=template&id=345f624e&scoped=true&"
import script from "./sceneImportTemplate.vue?vue&type=script&lang=js&"
export * from "./sceneImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./sceneImportTemplate.vue?vue&type=style&index=0&id=345f624e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f624e",
  null
  
)

export default component.exports